import { safelyDecodeBase64Url } from '@dev/ee-tools';
import { ContactListTypeEnum, ContactsList, ContactStatus } from '@dev/ee-api/ee-api-models';
import { ContactsPaths, pathsParams } from '@/services/dictionaries/Paths';

import i18n from '@/../i18n';


export const getPathParams = (segmentName: string, listName: string): string[] => {
    const path = !!segmentName ? ContactsPaths.SingleSegment : ContactsPaths.SingleList;
    const pathParam = !!segmentName ? pathsParams.segmentName : pathsParams.listName;
    const breadcrumbName = safelyDecodeBase64Url(segmentName || listName);

    return [path, pathParam, breadcrumbName];
};

export const prepareStatusInfo = (status: ContactStatus): string => {
    switch (status) {
        case ContactStatus.Abuse:
            return i18n.t('statusdesc_complaint');
        case ContactStatus.Inactive:
            return i18n.t('statusdesc_inactive');
        case ContactStatus.Transactional:
            return i18n.t('statusdesc_transactional');
        case ContactStatus.Unsubscribed:
            return i18n.t('statusdesc_unsubscribed');
        default:
            return i18n.t('statusdesc_active');
    }
}

export const isPaidSubscriptionList = (list: ContactsList): boolean => list.Type === ContactListTypeEnum.PaidSubscription;
